/**
 * Lightweight i18n system for Hashee Admin Console.
 * Detects locale from localStorage or browser language.
 * Simple reload-based switching (no lazy loading needed for small SPA).
 */

import { en } from "./en";
import { zh } from "./zh";

type Locale = "en" | "zh";

const translations: Record<Locale, Record<string, string>> = { en, zh };

function detectLocale(): Locale {
  const stored = localStorage.getItem("hashee_admin_locale");
  if (stored === "zh") return "zh";
  if (stored === "en") return "en";
  if (navigator.language.startsWith("zh")) return "zh";
  return "en";
}

let currentLocale: Locale = detectLocale();

export function setLocale(locale: Locale): void {
  currentLocale = locale;
  localStorage.setItem("hashee_admin_locale", locale);
  window.location.reload();
}

export function getLocale(): Locale {
  return currentLocale;
}

/**
 * Translate a key. Returns the key itself if no translation found.
 * Supports simple interpolation: t("key", { name: "Alice" }) replaces {{name}}.
 */
export function t(
  key: string,
  params?: Record<string, string | number>,
): string {
  let result = translations[currentLocale][key] ?? translations.en[key] ?? key;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      result = result.replace(`{{${k}}}`, String(v));
    }
  }
  return result;
}
